import React, { Component } from 'react';
import { Col, FormControl, Row } from 'react-bootstrap';
import moment, { isMoment } from 'moment';
import 'moment-precise-range-plugin';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../common/dateTimeFormats';

const dateData = {
  year: {
    name: 'year',
    stateName: 'yearCount',
    momentName: 'years',
  },
  month: {
    name: 'month',
    stateName: 'monthCount',
    momentName: 'months',
  },
  day: {
    name: 'day',
    stateName: 'dayCount',
    momentName: 'days',
  },
};

const getDateFields = (fields) => fields.map((i) => dateData[i]);

const componentsConfig = {
  licensePeriod: {
    fields: getDateFields(['month', 'day']),
    expirationLabel: 'Expiration date:',
    initState: {
      yearCount: 0,
      dayCount: 0,
      monthCount: 1,
    },
    timeFormat: DATE_TIME_FORMAT,
  },

  supportDayCount: {
    fields: getDateFields(['year', 'month', 'day']),
    expirationLabel: 'Support expiration date:',
    initState: {
      yearCount: 1,
      dayCount: 0,
      monthCount: 0,
    },
    timeFormat: DATE_FORMAT,
  },

  webViewerValidityTerm: {
    fields: getDateFields(['year', 'month', 'day']),
    expirationLabel: 'Web Viewer expiration date:',
    initState: {
      yearCount: 1,
      dayCount: 0,
      monthCount: 0,
    },
    timeFormat: DATE_FORMAT,
  },
};

class ExpirationDateEdit extends Component {
  constructor(props) {
    super(props);
    this.componentConfig = componentsConfig[props.elementType];
    this.displayedPeriodElements = this.componentConfig.fields;

    this.state = this.componentConfig.initState;

    if (props.term === null && props.enableUnlimited) {
      this.state = { ...this.componentConfig.initState, monthCount: 0 };
    }
  }

  componentDidMount() {
    const { startDate, term, enableUnlimited, onChange } = this.props;

    if (term === null && enableUnlimited) {
      return onChange(null);
    }

    if (!startDate || (!term && term !== 0)) return;

    const momentStartDate = isMoment(startDate) ? startDate : moment(startDate);
    const startDateClone = momentStartDate.clone();

    const dateWithTerm = startDateClone.add('days', term);
    const newState = {};
    const diff = moment.preciseDiff(momentStartDate, dateWithTerm, true);// true - object output format

    let isYearDisplayed = false;
    this.displayedPeriodElements.forEach((element) => {
      if (element.name === 'year')
        isYearDisplayed = true;
      newState[element.stateName] = diff[element.momentName]
    });
    if (!isYearDisplayed)
      newState[dateData.month.stateName] += diff[dateData.year.momentName] * 12;

    this.setState({ ...newState });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state) {
      const { startDate, onChange, enableUnlimited } = this.props;
      const momentStartDate = isMoment(startDate) ? startDate : moment(startDate);
      const term = momentStartDate.clone();

      this.displayedPeriodElements.forEach((i) => {
        term.add(i.momentName, this.state[i.stateName])
      });
      const diff = term.diff(startDate, 'days');

      if (enableUnlimited && diff === 0) {
        return onChange(null);
      }

      onChange(diff);
    }
  }

  handleChange(fieldName, value) {
    const re = /^\d+$/;
    if (value !== '' && !re.test(value)) return;
    this.setState({ [fieldName]: value });
  }

  getExpirationDate() {
    const { startDate, term, enableUnlimited } = this.props;
    if (!startDate) return;
    const momentStartDate = isMoment(startDate) ? startDate : moment(startDate);
    const startDateClone = momentStartDate.clone();

    this.displayedPeriodElements.forEach((element) => {
      const { momentName, stateName } = element;
      startDateClone.add(momentName, this.state[stateName])
    });

    if (enableUnlimited && (term === 0 || term === null)) {
      return 'unlimited';
    }

    return startDateClone.format(this.componentConfig.timeFormat);
  }

  render() {
    const { disabled, type, min } = this.props;
    return (
      <React.Fragment>
        <Row className="noMargin">
          {
            this.displayedPeriodElements.map((element) => {
              const value = this.state[element.stateName];
              const fieldName = element.stateName;
              const name = element.name;
              return (
                <Col sm={4} lg={4} md={4} key={name} style={{ marginRight: 0, padding: 0 }}>
                  <Col sm={6} lg={6} md={6} className="noPadding">
                    <FormControl value={value}
                                 disabled={disabled}
                                 type={type}
                                 min={min}
                                 onChange={(e) => this.handleChange(fieldName, e.target.value)}/>
                  </Col>
                  <Col sm={6} lg={6} md={6} className="noPadding">
                    <FormControl.Static className="units">{name}(s)</FormControl.Static>
                  </Col>
                </Col>
              );
            })
          }
        </Row>
        <Row className="noMargin">
          <Col sm={12} lg={12} md={12} className="noPadding">
            <FormControl.Static>
              {this.componentConfig.expirationLabel} {this.getExpirationDate()}
            </FormControl.Static>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

ExpirationDateEdit.defaultProps = {
  disabled: false,
  type: 'number',
  min: 0,
};

export default ExpirationDateEdit;



// WEBPACK FOOTER //
// ./src/components/expirationDateEdit.js